import request from "@/utils/request";

// 查询文创产品列表
export function listItem(query) {
  return request({
    url: "/cc-mall/item/list",
    method: "GET",
    params: query,
  });
}

// 查询文创产品详细
export function getItem(itemId) {
  return request({
    url: "/cc-mall/item/detail/" + itemId,
    method: "get",
  });
}

// 查询文创产品详细
export function getRateList(itemId) {
  return request({
    url: "/itemComment/selectCommentByID/" + itemId,
    method: "get",
  });
}

// 记录停留时间接口
export function stayTime(params, data) {
  return request({
    url: "/system/operlog",
    method: "post",
    // params: params,
    data: params,
  });
}
